export default "__VITE_ASSET__SUxYkQBY__"